import React, { useState, useEffect, useRef } from "react";
import "./submission.css";
import ProfileLayout from "../../components/layout/ProfileLayout";
import Submission from "./submission";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { API } from "../../api/axios"
import axios from "axios"; 
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCaretRight } from "@fortawesome/free-solid-svg-icons";


const SubmissionPage = () => {
  const [declinedOpen, setDeclinedOpen] = useState(false);
  const [expiredOpen, setExpiredOpen] = useState(false);
  const [pendingOpen, setPendingOpen] = useState(false);
  const [approvedOpen, setApprovedOpen] = useState(false);


  const [declinedSubmissions, setDeclinedSubmissions] = useState([]);
  const [expiredSubmissions, setExpiredSubmissions] = useState([]);
  const [pendingSubmissions, setPendingSubmissions] = useState([]);
  const [approvedSubmissions, setApprovedSubmissions] = useState([]);
  const [loading, setLoading] = useState(false);

  const [selectedCastingId, setSelectedCastingId] = useState(null);
  const [selectedCastingTitle, setSelectedCastingTitle] = useState(null);
  const [selectedRoleId, setSelectedRoleId] = useState(null);
  const submissionContentRef = useRef(null);

  const handleRoleSelect = (submission, role) => {
    setSelectedCastingId(submission.id);
    setSelectedRoleId(role.id);
    setSelectedCastingTitle(submission.title);

    requestAnimationFrame(() => {
      submissionContentRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    });
  };

  const fetchCastingCalls = async () => {
    try {
      setLoading(true);
      const callerId = localStorage.getItem("userId");
      if (!callerId) {
        console.error("User ID not found in local storage.");
        return;
      }

      const response = await API.get(`/casting/getUserCastingByCallerId/${callerId}`);
      const castingCalls = response.data.casting;
      // console.log("Casting Calls:", castingCalls);
      setSelectedCastingId(castingCalls[0]?.id);
      setSelectedRoleId(castingCalls[0]?.roles[0]?.id);
      setSelectedCastingTitle(castingCalls[0]?.title);

      const firstCastingStatus = castingCalls[0]?.adminStatus;
      switch(firstCastingStatus){
        case "approved":
              setApprovedOpen(true);
              break;
        case "pending" :
              setPendingOpen(true);
              break;
        case "declined" :
              setDeclinedOpen(true);
              break;
        case "expired" :
              setExpiredOpen(true);
              break;
      }

      const currentDate = new Date();
      const expired = [];
      const declined = [];
      const pending = [];
      const approved = [];

      castingCalls
        .slice()
        .sort((a, b) => new Date(b.createdAt || b.updatedAt || 0) - new Date(a.createdAt || a.updatedAt || 0))
        .forEach((casting) => {
          const expirationDate = new Date(casting.expirationDate);
          const adminStatus = casting.adminStatus;

          if (expirationDate < currentDate) {
            expired.push(casting);
          } else if (adminStatus === "rejected") {
            declined.push(casting);
          } else if (adminStatus === "pending") {
            pending.push(casting);
          } else if (adminStatus === "approved") {
            approved.push(casting);
          }
        });

      setExpiredSubmissions(expired);
      setDeclinedSubmissions(declined);
      setPendingSubmissions(pending);
      setApprovedSubmissions(approved);
    } catch (error) {
      console.error("Error fetching casting calls:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCastingCalls();
  }, []);

  return (
    <div className="submission-main">
      <ProfileLayout style={{ width: "100%" }}>
        <div className="submission">
          <div className="submission-sidebar">
            <div className="search-box">
              <h4>Admin Responses</h4>
              <hr />
            </div>
            <nav className="castingcall-list">
              {/* Approved Submissions */}
              <div className="dropdown" onClick={() => setApprovedOpen(!approvedOpen)}>
                <h4>
                  Approved
                </h4>
                <span>{approvedOpen ? <FaChevronUp /> : <FaChevronDown />}</span>
              </div>
              {approvedOpen && (
                <ul className="SubmissionPageList">
                  {loading ? (
                    <li>Loading...</li>
                  ) : (
                    approvedSubmissions.map((submission) => (
                      <li key={submission.id} className="submission-title">
                        {submission.title}
                        {submission.roles && (
                          <ul className="SubmissionPageList">
                            {submission.roles.map((role) => (
                              <li 
                                key={role.id} 
                                onClick={() => handleRoleSelect(submission, role)}
                                className={`submission-role-item ${selectedRoleId === role.id ? "selected-role" : ""}`}
                              >
                              <FontAwesomeIcon icon={faCaretRight} />
                              <b> {role.title} </b> 
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))
                  )}
                </ul>
              )}
              <hr />

              {/* Pending Submissions */}
              <div className="dropdown" onClick={() => setPendingOpen(!pendingOpen)}>
                <h4>
                  Pending
                </h4>
                <span>{pendingOpen ? <FaChevronUp /> : <FaChevronDown />}</span>
              </div>
              {pendingOpen && (
                <ul className="SubmissionPageList">
                  {loading ? (
                    <li>Loading...</li>
                  ) : (
                    pendingSubmissions.map((submission) => (
                      <li key={submission.id} className="submission-title">
                        {submission.title}
                        {submission.roles && (
                          <ul className="SubmissionPageList">
                            {submission.roles.map((role) => (
                              <li 
                                key={role.id} 
                                onClick={() => handleRoleSelect(submission, role)}
                                className={`submission-role-item ${selectedRoleId === role.id ? "selected-role" : ""}`}
                              >
                                <FontAwesomeIcon icon={faCaretRight} />
                                <b> {role.title} </b>
                              </li>
                            ))}
                            <hr />
                          </ul>
                        )}
                      </li>
                    ))
                  )}
                </ul>
              )}
              <hr />

              {/* Declined Submissions */}
              <div className="dropdown" onClick={() => setDeclinedOpen(!declinedOpen)}>
                <h4>
                  Rejected
                </h4>
                <span>{declinedOpen ? <FaChevronUp /> : <FaChevronDown />}</span>
              </div>
              {declinedOpen && (
                <ul className="SubmissionPageList">
                  {loading ? (
                    <li>Loading...</li>
                  ) : (
                    declinedSubmissions.map((submission) => (
                      <li key={submission.id} className="submission-title">
                        {submission.title}
                        {submission.roles && (
                          <ul className="SubmissionPageList">
                            {submission.roles.map((role) => (
                              <li 
                                key={role.id} 
                                onClick={() => handleRoleSelect(submission, role)}
                                className={`submission-role-item ${selectedRoleId === role.id ? "selected-role" : ""}`}
                              >
                                <FontAwesomeIcon icon={faCaretRight} />
                                <b> {role.title} </b>
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))
                  )}
                </ul>
              )}
              <hr />

              {/* Expired Submissions */}
              <div className="dropdown" onClick={() => setExpiredOpen(!expiredOpen)}>
                <h4>
                  Expired
                </h4>
                <span>{expiredOpen ? <FaChevronUp /> : <FaChevronDown />}</span>
              </div>
              {expiredOpen && (
                <ul className="SubmissionPageList">
                  {loading ? (
                    <li>Loading...</li>
                  ) : (
                    expiredSubmissions.map((submission) => (
                      <li key={submission.id} className="submission-title">
                        {submission.title}
                        {submission.roles && (
                          <ul className="SubmissionPageList">
                            {submission.roles.map((role) => (
                              <li 
                                key={role.id} 
                                onClick={() => handleRoleSelect(submission, role)}
                                className={`submission-role-item ${selectedRoleId === role.id ? "selected-role" : ""}`}
                              >
                                <FontAwesomeIcon icon={faCaretRight} />
                                <b> {role.title} </b> 
                              </li>
                            ))}
                          </ul>
                        )}
                      </li>
                    ))
                  )}
                </ul>
              )}
            </nav>
          </div>
          <div className="submission-content" ref={submissionContentRef}>
            <Submission castingId={selectedCastingId} roleId={selectedRoleId} castingTitle={selectedCastingTitle}/>
          </div>
        </div>
      </ProfileLayout>
    </div>
  );
};

export default SubmissionPage;
